import * as React from "react"
import uniqueId from "app/helpers/unique_id"
import trans from "trans"
import {css, Icon, Theme} from "@bdfx/mergado-ui-kit";
import Mergado from "app/helpers/mergado";
import {MERGADO_APP, projectId} from "app/helpers/api";
import { PreviewImage } from "template-previews/types";
import { RENDERED_TYPE_UPSCALE } from "products/types";

export interface Props {
    idx: number
    image: PreviewImage,
    isTemplateActive: boolean
    templateActiveFrom: string
    templateActiveTo: string
    style: any
    showModal: Function
    showUnmodified: boolean
}

export interface State {
}

class Image extends React.Component<Props, State> {
    render() {
        const { image, showUnmodified, isTemplateActive, templateActiveFrom, templateActiveTo, idx} = this.props
        const shopUrl = image.shopUrl || null
        const mergadoProductUrl = `${MERGADO_APP}/${image.id}`

        if (image && !image.imageUrl) {
            return (
                <div className={`no-preview-image`} key={`${uniqueId()}`}>
                    <div style={{padding: '20px', cursor: 'pointer'}} onClick={() => Mergado.openWindow(mergadoProductUrl)} title={trans("link_mergado")}>
                        <Icon type="eye-slash" color={Theme.steelblue} size={80} />
                    </div>

                    <div style={{padding: '20px'}}>
                        {trans('no_image')}
                    </div>

                    {image.itemId &&
                    <span title={'ITEM_ID'}>
                            <Icon type={'tag'} className={'item_id'} text={`${image.itemId}`} color={Theme.steelblue} /><br/>
                        </span>
                    }

                    <div onClick={() => Mergado.openWindow(mergadoProductUrl)} title={trans("link_mergado")} style={{cursor: 'pointer'}}>
                        <Icon type={'mergado'} className={'product_id'} text={`${image.id}`} />
                    </div>

                    <div style={{
                        padding: '20px',
                        fontSize: '12px',
                    }}>
                        <a href={image.shopUrl} className={'shop_url'} title={trans('shop_link')} target={"_blank"}>
                            {image.shopUrl}
                        </a>
                    </div>
                </div>
            )
        }

        const templateName = (image.templateName) ? <div className="tag-name">{image.templateName}<StyledShopLink onClick={() => Mergado.openWindow(shopUrl)}><Icon type={'shopping-basket'} size={20} /></StyledShopLink></div> : <span />

        const dateNow = new Date(new Date().toISOString().slice(0, 10))
        const dateFrom = templateActiveFrom ? new Date(templateActiveFrom) : null
        const dateTo = templateActiveTo ? new Date(templateActiveTo) : null

        const isActiveNow = ((!dateFrom || (dateFrom <= dateNow)) && (!dateTo || (dateTo >= dateNow)))
        const imageSrc = showUnmodified ? image.imageUrl : image.previewUrl

        const onErrorFunction = (event) => {
            if (event.currentTarget.parentNode) {
                event.currentTarget.parentNode.removeChild(event.currentTarget)
            }
        }

        return (
            <div style={{position: 'relative', cursor: 'pointer'}} onClick={() => this.props.showModal(idx)}>
                {templateName}

                <img className={'checker shadow-box'} src={imageSrc} style={{ width: '100%', height: 'auto'}} onError={onErrorFunction} loading="lazy" />

                {image.renderedType === RENDERED_TYPE_UPSCALE &&
                <div className="tag is-upscaled">{trans('image_is_upscaled')}</div>
                }

                {!isTemplateActive || !isActiveNow &&
                    <div className={`tag ${!isActiveNow ? ' tag-active-date' : ''}`}>
                        {!isTemplateActive ?
                            trans('inactive')
                            :
                            <>
                                <span>({trans('not_active')})</span><br/>
                                <span>{trans('active')} </span>
                                {templateActiveFrom &&
                                <span> {trans('from_date')} {templateActiveFrom} </span>
                                }
                                {templateActiveTo &&
                                <span> {trans('to_date')} {templateActiveTo}</span>
                                }
                            </>
                        }
                    </div>
                }
            </div>
        )
    }
}

const StyledShopLink = css('span')({
    cursor: 'pointer',
    float: 'right',
    " .muk-icon": {
        ' g.m-group path': {
            fill: '#fff !important',
        },
    },
})

export default Image